export const keyEventEndPoints = {
    prod: ['pdx', 'iad', 'dub', 'nrt', 'syd', 'cmh', 'icn', 'lhr', 'cdg', 'bom', 'bah', 'mxp', 'hkg', 'cpt', 'sfo', 'fra', 'gru', 'sin', 'yul', 'arn', 'yyc']
}